// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"52":"57c582f6","116":"4f827cee","191":"ae1c5792","339":"6496cda0","439":"f9106ea7","459":"cc135de2","970":"bcfee2df"}[chunkId] + ".chunk.css";
};